// ------------------------------------
// Listas dinâmicas dos formulários
// ------------------------------------

// Gera o próximo ID (Fictício)
function formListGenerateID($list) {
  let maxID = 0;
  $list.find('[data-item]').each(function () {
    const curID = Number($(this).data('item'));
    if (curID > maxID) {
      maxID = curID;
    }
  });
  return maxID + 1;
}

// Adiciona um item na lista
function formListAdd($list, item) {
  $list.append(item);
  formListUpdate($list);
  initTooltips();
  initInputMask();
  initSpinners();
  initTagsInput();
}

// Remove um item da lista
function formListDel($list, idItem) {
  const $item = $list.find(`[data-item="${idItem}"]`);
  $item.find('[data-toggle="tooltip"]').tooltip('hide');
  $item.remove();
  formListUpdate($list);
}

// Limpa uma lista
function formListClear($list) {
  $list.html('');
  formListUpdate($list);
}

// Retorna o total de itens de uma lista
function formListGetTotal($list) {
  return $list.find(`[data-item]`).length;
}

// Verifica se atingiu o limite de itens
function formListIsFull($list) {
  const total = formListGetTotal($list);
  const limit = $list.data('list-limit') ? Number($list.data('list-limit')) : 100;
  return total >= limit;
}

// Atualiza lista
function formListUpdate($list) {
  const $btnAdd = $(`[data-list-add="${$list.data('list')}"]`);
  if (formListIsFull($list)) {
    $btnAdd.hide();
  } else {
    $btnAdd.show();
  }
}
